import { render, staticRenderFns } from "./comNav.vue?vue&type=template&id=4762edec&scoped=true&"
import script from "./comNav.vue?vue&type=script&lang=js&"
export * from "./comNav.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./comNav.vue?vue&type=style&index=0&id=4762edec&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4762edec",
  "0179cbd2"
  
)

export default component.exports